import { useRef } from 'react';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';

import WhyChooseUsSectionStyle from './style';

import SlideCard from 'src/components/atoms/slideCard';
import { useScrollPosition } from 'src/helpers/use';

const CARD_DATA = [
  {
    icon: 'variety',
    key: 'variety',
  },
  {
    icon: 'system-management',
    key: 'system_management',
  },
  {
    icon: 'customization',
    key: 'customization',
  },
  {
    icon: 'assessment',
    key: 'assessment',
  },
  {
    icon: 'evaluation',
    key: 'evaluation',
  },
  {
    icon: 'personalization',
    key: 'personalization',
  },
  {
    icon: 'dashboard',
    key: 'dashboard',
  },
  {
    icon: 'book-summaries',
    key: 'book_summaries',
  },
  {
    icon: 'leading-instructors',
    key: 'leading_instructors',
  },
  {
    icon: 'efficiency',
    key: 'efficiency',
  },
  {
    icon: 'support',
    key: 'support',
  },
  {
    icon: 'course-production',
    key: 'course_production',
  },
];

const WhyChooseUsSection = () => {
  const { t } = useTranslation('business');
  const [hasScroll, scrollPosition] = useScrollPosition('cardList');
  const elementRef = useRef(null);

  const next = () => {
    const element: any = elementRef.current;
    if (element) element.scrollTo({ left: element.scrollLeft + 190, behavior: 'smooth' });
  };

  const previous = () => {
    const element: any = elementRef.current;
    if (element) element.scrollTo({ left: element.scrollLeft - 190, behavior: 'smooth' });
  };

  return (
    <WhyChooseUsSectionStyle>
      <div className="container">
        <Typography className="title-eng">{t('why_choose_us_subtitle')}</Typography>
        <Typography className="title">{t('why_choose_us_title')}</Typography>
        <Typography className="subtitle">{t('why_choose_us_description')}</Typography>
        <Typography className="subtitle">{t('why_choose_us_description_more')}</Typography>
      </div>
      <Box position="relative">
        {hasScroll && scrollPosition !== 1 && (
          <Box className="next-button" onClick={next}>
            <KeyboardArrowRightIcon />
          </Box>
        )}
        {hasScroll && scrollPosition !== 0 && (
          <Box className="previous-button" onClick={previous}>
            <KeyboardArrowLeftIcon />
          </Box>
        )}
      </Box>

      <div className="container">
        <Box overflow="auto" paddingBottom={2} id="cardList" ref={elementRef}>
          <Grid container spacing={1} paddingTop="50px" width="1150px">
            {CARD_DATA.map((card) => (
              <Grid item xs={2} display="flex" key={card.key}>
                <SlideCard
                  size={180}
                  frontElement={
                    <div className="front-card">
                      <img src={`/static/icons/${card.icon}.svg`} alt={t(`${card.key}_alt`)} />
                      <Typography>{t(`${card.key}_name`)}</Typography>
                    </div>
                  }
                  backElement={
                    <div className="back-card">
                      <Box textAlign="right">
                        <img src={`/static/icons/grey-${card.icon}.svg`} alt={card.icon} />
                      </Box>
                      <Typography className="title">{t(`${card.key}_name`)}</Typography>
                      <Typography className="content">{t(`${card.key}_content`)}</Typography>
                    </div>
                  }
                  cardStyle={{
                    borderRadius: 5,
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </div>
    </WhyChooseUsSectionStyle>
  );
};

export default WhyChooseUsSection;
